export default "/_next/static/media/enjoei-homepage.d847c7e5839f5917115f6c17904e2734.png";